import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PrintersState } from '../reducers/printers.reducer';
import { PRINTERS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<PrintersState>(PRINTERS_FEATURE_KEY);

export const selectPrinters = createSelector(selectState, (state: PrintersState) => state.printers);
export const selectStatuses = createSelector(selectState, (state: PrintersState) => state.statuses);
export const selectLabelDimensions = createSelector(selectState, (state: PrintersState) => state.labelDimensions);
export const selectLoaded = createSelector(selectState, (state: PrintersState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: PrintersState) => state.loading);
